let _baseUrl = process.env.VUE_APP_BASEURL;
let _webappUrl = process.env.VUE_APP_WEBAPP_URL;
let _appMode = process.env.VUE_APP_MODE;

export let baseUrl = _baseUrl;
export let webappUrl = _webappUrl;
export let appMode = _appMode